import { MODEL_NAMES } from '../../constants/index';
import { didCancel, task } from 'ember-concurrency';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import MessagingRoutesBaseHandler from './base-handler.js';

export default class MessagingRoutesAddMembersHistoryHandler extends MessagingRoutesBaseHandler {
  @service('spds/toast') toast;
  @service intl;
  @service messagingLogging;
  @service messagingNavigation;
  @service store;

  @tracked historyMode = null;

  get contactsHandler() {
    return this.options.parentHandler;
  }

  get conversation() {
    return this.contactsHandler.conversation;
  }

  get newMembers() {
    return this.options.newMembers;
  }

  get isContinueDisabled() {
    return !this.historyMode || this.submit.isRunning;
  }

  selectHistoryMode = ({ value }) => {
    this.historyMode = value;
  };

  submit = task({ drop: true }, async () => {
    try {
      const members = this.newMembers;
      const payload = await this.store
        .adapterFor(MODEL_NAMES.CONVERSATION)
        .addMembers(this.conversation, {
          members,
          historyMode: this.historyMode,
        });
      this.store.pushPayload(MODEL_NAMES.CONVERSATION, payload);
      await this.messagingNavigation.toConversationDetails();
      this.#toastAddMembersSuccess(members);
    } catch (error) {
      if (didCancel(error)) return;
      this.messagingLogging.error(error);
      this.toast.error(this.intl.t('emc.general_error'));
    }
  });

  #toastAddMembersSuccess(members) {
    if (members.length === 1) {
      this.toast.success(
        this.intl.t('emc.add_team_members.success_one', { name: members[0].name })
      );
      return;
    }

    this.toast.success(this.intl.t('emc.add_team_members.success'));
  }
}
